/**
 * Collection Footer Content
 * Handles the FAQ accordion and the "View More / View Less" toggle.
 * Loaded with `defer`, so the DOM is already parsed by the time this runs —
 * no DOMContentLoaded listener needed.
 */
(function () {
  var footer = document.querySelector('.collection-footer-content');
  if (!footer) return;

  // FAQ accordion — one delegated listener on the list instead of one
  // per item. Keeps script work (and INP impact) low even with many FAQs.
  var faqList = footer.querySelector('.faq-list');
  if (faqList) {
    faqList.addEventListener('click', function (event) {
      var item = event.target.closest('.faq-item');
      if (!item) return;
      item.classList.toggle('active');
    });
  }

  // View More / View Less toggle
  var toggleBtn = document.getElementById('viewMoreToggle');
  var contentBox = document.getElementById('viewMoreContent');

  if (toggleBtn && contentBox) {
    toggleBtn.addEventListener('click', function () {
      var expanded = contentBox.classList.toggle('expanded');
      toggleBtn.textContent = expanded ? 'View Less' : 'View More';
    });
  }
})();